import React from 'react';
import { Row } from 'react-bootstrap';

import Accordion from 'components/Accordion';
import Checkbox from 'components/DesignSystem/Checkbox';
import ConfirmationModal from 'components/PreferenceDialog/Success';
import ErrorModal from 'components/PreferenceDialog/Error';
import { useClosure } from 'utils/hooks';
import useControlPanelUtility from 'hooks/Meteorology/Weather/SeasonalForecast/useControlPanelUtility';
import useLayers from 'hooks/Meteorology/Weather/SeasonalForecast/useLayers';
import useSavePreference from 'hooks/Meteorology/Weather/SeasonalForecast/useSavePreference';
import Button from 'components/DesignSystem/Button';
import FormModal from 'components/PreferenceModals/FormModal';
import Preferences from './Preferences';
import Variables from './Variables';
import Models from './Models';
import Area from './Area';
import Period from './Period';
import Dates from './Dates';

export default function SeasonalForecastControlPanel() {
  const { clearFilters } = useControlPanelUtility();
  const { layer, toggleLayers } = useLayers();
  const {
    valid,
    isLoading,
    showFormModal,
    showConfirmationModal,
    showErrorModal,
    errorMessage,
    onNameChange,
    handleSubmit,
    setShowFormModal,
    setShowConfirmationModal,
    setShowErrorModal,
  } = useSavePreference();

  return (
    <div>
      <ConfirmationModal
        open={showConfirmationModal}
        closing={useClosure(setShowConfirmationModal, false)}
      />
      <ErrorModal
        open={showErrorModal}
        closing={useClosure(setShowErrorModal, false)}
        message={errorMessage}
      />
      <FormModal
        show={showFormModal}
        valid={valid}
        isLoading={isLoading}
        onHide={useClosure(setShowFormModal, false)}
        onNameChange={onNameChange}
        handleSubmit={handleSubmit}
      />
      <Accordion defaultActiveKey="0">
        <Preferences />
        <Variables />
        <Models />
        <Area />
        <Dates />
        <Period />
      </Accordion>
      <Checkbox
        id="anomaly-checkbox"
        className="mt-4"
        label="Mostrar camadas"
        checked={layer}
        onChange={() => toggleLayers()}
      />
      <Row className="pt-5">
        <Button
          onClick={useClosure(setShowFormModal, true)}
        >
          Salvar nova preferência
        </Button>
      </Row>
      <Row>
        <Button type="tertiary" className="clear-filters mt-1" onClick={clearFilters}>
          Limpar filtros
        </Button>
      </Row>
    </div>
  );
}
